export const hotelBookingHeaders = [
  { columnName: 'Country', required: true },
  { columnName: 'Place', required: true },
  { columnName: 'Check-in Date', required: true },
  { columnName: 'Check-out Date', required: true },
  { columnName: 'Hotel Name', required: false },
  { columnName: 'Traveller', required: false },
];
